/* Bamgum rabattpopup: visas några sekunder efter sidstart, steg 1 -> e-post -> tack. Visas inte igen på en vecka om den stängts. */
(function () {
  const root = document.querySelector('[data-bg-popup]');
  if (!root) return;
  const KEY = 'bg-popup-until';
  const store = {
    get() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } },
    set(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} },
  };
  const days = parseInt(root.dataset.snoozeDays, 10) || 7;
  const delay = (parseInt(root.dataset.delay, 10) || 40) * 1000;
  const preview = /[?&]popup=1\b/.test(location.search); // ?popup=1 visar alltid popupen (för test)
  if (!preview && store.get() > Date.now()) return;
  if (/\/(checkouts?|cart)(\/|$)/.test(location.pathname)) return;

  let shown = false;
  const steps = root.querySelectorAll('[data-bg-popup-step]');
  const go = (n) => steps.forEach((s) => { s.hidden = s.dataset.bgPopupStep !== String(n); });
  const desktop = window.matchMedia('(min-width: 750px)');
  const open = () => {
    if (shown) return;
    shown = true;
    root.hidden = false;
    if (desktop.matches) document.documentElement.classList.add('bg-popup-open');
  };
  // Vänta tills cookie-rutan är besvarad så att de inte täcker varandra
  const cookieBannerVisible = () => {
    const b = document.getElementById('shopify-pc__banner');
    return !!(b && getComputedStyle(b).display !== 'none' && b.getBoundingClientRect().height > 0);
  };
  const close = () => {
    root.hidden = true;
    document.documentElement.classList.remove('bg-popup-open');
    if (!preview) store.set(Date.now() + days * 86400000);
  };

  root.querySelectorAll('[data-bg-popup-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });

  const form = root.querySelector('#bgPopupForm');
  const error = root.querySelector('[data-bg-popup-error]');
  // Anmälan skickas som ett vanligt formulär till Shopify (sparar kunden med e-postsamtycke) och sidan laddas om
  form?.addEventListener('submit', (e) => {
    const email = form.querySelector('#bgPopupEmail').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      e.preventDefault();
      error.hidden = false;
      return;
    }
    // Andra skript på sidan kan stoppa formulärets submit-händelse, så vi skickar det direkt (utan händelse)
    e.preventDefault();
    e.stopImmediatePropagation();
    form.querySelector('button[type=submit]').disabled = true;
    HTMLFormElement.prototype.submit.call(form);
  }, true);

  // Efter att formuläret skickats kommer Shopify tillbaka till sidan: visa tacket (eller felet)
  if (form?.querySelector('[data-bg-popup-posted]') || /[?&]customer_posted=true/.test(location.search)) {
    store.set(Date.now() + 365 * 86400000);
    go('done');
    shown = false;
    open();
    return;
  }
  if (form?.querySelector('[data-bg-popup-failed]')) {
    error.hidden = false;
    shown = false;
    open();
    return;
  }

  // Timer: visas {delay} sekunder efter att besöket startade. Är cookie-rutan uppe räknar vi inte, och
  // tiden startar om först när den besvarats, så popupen aldrig kommer direkt när någon klickat Godkänn.
  let startedAt = Date.now();
  try {
    const saved = parseInt(sessionStorage.getItem('bg-popup-t0'), 10);
    if (saved && saved <= Date.now()) startedAt = saved; else sessionStorage.setItem('bg-popup-t0', String(startedAt));
  } catch (err) {}
  const tick = () => {
    if (shown) return;
    if (cookieBannerVisible()) {
      startedAt = Date.now();
      try { sessionStorage.setItem('bg-popup-t0', String(startedAt)); } catch (err) {}
    } else if (Date.now() - startedAt >= (preview ? 800 : delay)) {
      open();
      return;
    }
    setTimeout(tick, 500);
  };
  setTimeout(tick, 500);
})();
